import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import { getSettingsData } from '../reducer';
import { dateTimeFormatter, RoleFormater } from '../../../utils/formatters';
import TextInput from '../../../components/fields/TextInput/TextInput';
import Grid from '../../../components/base/Grid/Grid';
import { getSystemData } from '../../System/reducer';
import { loadUserAction } from '../actions';
import { responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';

export default function ActionColumn() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isShowForm, setIsShowForm] = useState(false);
  const [filter, setFilter] = useState('');
  const { updatePeriod } = useSelector(getSystemData);
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    userList = [],
    loadingUserList = false,
    loadingUserAction,
    userAction,
  } = useSelector(getSettingsData);
  const dispatch = useDispatch();
  const loadData = () => {
    const promises = [];
    if (selectedUser) {
      promises.push(dispatch(loadUserAction(selectedUser)).catch(responseLogWithNotification));
    }
    return Promise.all(promises);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod, selectedUser]);
  const columns = [
    {
      dataField: 'date',
      text: formatMessage({ id: 'action.date' }),
      formatter: dateTimeFormatter,
      headerClassName: 'date-column',
      disableSort: true,
    },
    {
      dataField: 'action',
      text: formatMessage({ id: 'action.action' }),
      headerClassName: 'action-column',
      disableSort: true,
    },
  ];

  const selectedItem = userList.find(item => item.id === selectedUser);
  const filteredUserList = (userList || []).filter(item => String(item.username).toLowerCase().includes(String(filter).toLowerCase()));
  return (
    <>
      <div className="settings-category frame">
        <Loader loading={loadingUserList || loadingUserAction} />
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'users' })}</div>
          <div className="settings-buttons" />
        </div>
        <div className="settings-list-find">
          <TextInput
            inputProps={{
              value: filter,
              onChange: e => setFilter(e.target.value),
            }}
            placeholder={formatMessage({ id: 'search' })}
            inputAfter={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}

          />
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme with-find">
            {filteredUserList.map((item, key) => (
              <div
                key={key}
                onClick={() => {
                  setSelectedUser(item.id);
                }}
                className={classNames('settings-menu-item', { selected: selectedUser === item.id })}
              >{item.username}
              </div>
            ))}
            {!userList.length ? (
              <div className="empty-list">
                <div className="empty-list-text">{formatMessage({ id: 'users.not.found' })}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="settings-options frame">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'user.activity.log' })}</div>
          <div className="settings-buttons">
            <TextInput
              inputProps={{
                value: '',
                onChange: () => {
                },
              }}
              placeholder={formatMessage({ id: 'date' })}
              className="no-border date-filter ms-auto"
              inputAfter={(
                <div className="search-wrapper">
                  <Icons customIcon className="search" width={24} height={24} icon="calendar" />
                </div>
              )}

            />
          </div>
        </div>
        {!selectedItem && !isShowForm ? (
          <div className="settings-form empty-list">
            <div className="empty-list-text">{formatMessage({ id: 'users.need.select' })}</div>
          </div>
        ) : null}

        {selectedItem
          ? (
            <div className="settings-form">
              <div className="settings-view-form user-action">
                <div className="user-action-wrapper">
                  <Grid columns={columns} data={userAction} />
                </div>
              </div>
            </div>
          ) : null}
      </div>
    </>
  );
}
